import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-full-screen-popup',
  templateUrl: './full-screen-popup.component.html',
  styleUrls: ['./full-screen-popup.component.scss']
})
export class FullScreenPopupComponent {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() tabs: any[] = [];
  @Input() isForAgrrment: boolean = false;

  constructor(protected dialogRef: NbDialogRef<FullScreenPopupComponent>) {}

  close(): void {
    this.dialogRef.close({ isReview: true, isApproval: false });
  }

  approve(): void {
    this.dialogRef.close({ isReview: false, isApproval: true });
  }

  onTabClick(tab:any){
    this.dialogRef.close({ isInvalidTabs: true,tabData:tab });
  }
}
